export const LARGE_LAYOUT_THRESHOLD = 1440;
export const MEDIUM_LAYOUT_THRESHOLD = 1000;
export const SMALL_LAYOUT_THRESHOLD = 768;

export const LARGE_LAYOUT_THRESHOLD_HEIGHT = 1020;
export const MEDIUM_LAYOUT_THRESHOLD_HEIGHT = 845;
export const SMALL_LAYOUT_THRESHOLD_HEIGHT = 728;
